export default {
  namespaced: true,
  state: {
    showLiveVideoOverlay: false,
    isPatientCameraPlaying: false,
    isMinimized: false,
    meetingMetaData: {
      device: null,
      patient_monitor: null,
      patient: null,
      kiosk_mode: null,  // whether kiosk mode is enabled on the device
      meeting_id: null,
      is_ptz: false
    },
    monitor: null,
    requestVideoStart: false,
    isPopupMode: true,
    isExternal: false
  },
  mutations: {
    setMeetingMetaData(state, metaData) {
      state.meetingMetaData = { ...state.meetingMetaData, video_reason_id: null, ...metaData, ...{ test_mode: false } }
    },
    setTestMeetingMetaData(state, metaData) {
      state.meetingMetaData = { ...state.meetingMetaData, video_reason_id: null, ...metaData, ...{ test_mode: true } }
    },
    setMonitor(state, id) {
      state.monitor = id
    },
    setIsMinimized(state, isMinimized) {
      state.isMinimized = isMinimized
    },
    setShowLiveVideoOverlay(state, isDisplayed) {
      state.showLiveVideoOverlay = isDisplayed
    },
    setPatientCameraIsPlaying(state, isPlaying) {
      state.isPatientCameraPlaying = isPlaying
    },
    setRequestVideoStart(state, value) {
      state.requestVideoStart = value
    },
    setIsPopupMode(state, value) {
      state.isPopupMode = value
    },
    setIsExternal(state, value) {
      state.isExternal = value
    }
  }
}
